import {imagesContext} from "./imagesContext"


/**
 *  Returns a list of all images, regardless of category and puts them into a form for tabs
 *
 * @param { object } categoryImageList - also known as giftcard.custom_images
 *
 * @return { array } imgList - list of all images
 */
// export const getAllImagesTabs = (categoryImageList) => {
//   const imgList = [];
//   const allImageList = categoryImageList.all || [];
//
//   if (typeof(allImageList) == 'undefined') return imgList;
//
//   allImageList.forEach((img) => {
//     const imgCategory = getImgCategory(img, categoryImageList);
//     imgList.push({
//       id: img,
//       source: img,
//       category: imgCategory ? titleCase(imgCategory) : "Uncategorized",
//     });
//   });
//   return imgList;
// };

/**
 *  Returns the image category
 *
 * @param { string } imgName - the name of the image
 * @param { object } categoryImageList - also known as giftcard.custom_images
 *
 * @return { string } category - the category of the image. Null if no category found.
 */
export const getImgCategory = (imgName, categoryImageList) => {

  for (const [category, imgList] of Object.entries(categoryImageList)) {

    if (Object.entries(imgList).includes(imgName)) return category;
  }
  // If img is not found in category, could be found in 'all' list.
  return categoryImageList.all.includes(imgName) ? "all" : null;
};

/**
 *  Returns if the image has been selected and is in giftcard.selected_images
 *
 * @param { string } imgSource - the path of the image
 * @param { object } selectedImages - also known as giftcard.selected_images
 *
 * @return { string } category - the category of the image. Null if no category found.
 */
export const isImageSelected = (imgSource, selectedImages) => {

  for (const imgCategory of Object.keys(selectedImages)) {
    for (const imgUrl of Object.values(selectedImages[imgCategory])) {

      if (imgUrl === getImgFileName(imgSource)) return true;
    }
  }

  return false;
};

 /**
   * Get the images associated with a category
   */
 export const getImageList = (categoryName, settings, fulfillmentType) => {

  const selectedImages = settings[fulfillmentType]?.greeting_card.selected_images;

  const imgIndex       = selectedImages.findIndex((category) => category.name === categoryName);

  const imgList        = selectedImages[imgIndex] && selectedImages[imgIndex].images ? selectedImages[imgIndex].images : [];

  return imgList;

};


/**
 * Gets a lost of populated image categories
 */
export const populatedCategories = (settings, fulfillmentType) => {

  const categories = settings[fulfillmentType]?.greeting_card.categories.filter((category, index) => {

    const imgList = getImageList(category, settings, fulfillmentType);

    return imgList.length > 0;

  });

  return categories;

};


/**
 * Simple helperfunction make a simple string titlecase. Not for complicated strings.
 *
 * @param { string } str - a string you want to have title case.
 *
 * @return { string } str -  in titlecase.
 */
export function titleCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function(word) {
      if (typeof(word[0]) === "string") return word.replace(word[0], word[0].toUpperCase());
    })
    .join(" ");
}

export const getWebpackImage = (imgSource, baseUrl) => {
  
  imgSource = imgSource.split("?")[0];
  // Handles preset images.
  imgSource = imagesContext(imgSource);

  // Remove undefined appended to beginning of imagesContext repsonse (unresolved webpack bug)
  if (imgSource.startsWith("undefined")) {
    imgSource = imgSource.replace("undefined", "");
  }

  if (imgSource.includes(baseUrl)) {
    return `${imgSource.replace(" ", '%20')}`;
  }

  if (imgSource.includes("https") || imgSource.includes("http")) {
    return imgSource;
  }

  return `${baseUrl}${imgSource.replace(" ", '%20')}`;

}

/**
 * Get an image saved to the application directory, as apposed to the upload directory.
 * @dependent {imagesContext}
 */
export const getPresetImage = (imgSource, baseUrl) => {

  const fileName = imgSource.split("./presets/")[1];
  
  if (fileName.includes("https:") || fileName.includes("http:")) {
    return fileName;
  }

  return `${baseUrl}/assets/presets/${fileName}`;

}

const getShopDir = () => {

  if (typeof(window.APP_ADMIN) != 'undefined') {
    return window.APP_ADMIN.request.params.shop;
  }

  if (typeof(window.Shopify) !== 'undefined' && typeof (window.Shopify.shop) != 'undefined') {
    return window.Shopify.shop;
  }
  
  return "dev";

}

/**
 * Gets the images loaction, either it is a preset image in which 'imagesContext'
 * can be used or it is a user uploaded image and needs a file path.
 *
 * @param { string } str - img source or img name
 */
export const getImage = (imgSource, folder = "images") => {

  const baseUrl   = process.env.BASE_CDN_URL || (typeof(GIST) != 'undefined' && typeof(GIST.base_cdn_url) != 'undefined' ? GIST.base_cdn_url : APP_ADMIN.base_cdn_url);
  const s3Url     = process.env.S3_URL || (typeof(GIST) != 'undefined' && typeof(GIST.s3_url) != 'undefined' ? GIST.s3_url : APP_ADMIN.s3_url);
  const shopDir   = getShopDir();
  const path      = `/uploads/${shopDir}/${folder}`;


  if (typeof(imgSource) == "undefined" || typeof(imgSource) != "string" || !imgSource) {
    return `${baseUrl}/not-found.jpg`;
  }

  // The url is already fully build - no need to modify
  if (imgSource.includes(s3Url) || imgSource.includes(baseUrl) || imgSource.includes("http") || imgSource.includes("https") ){
    return imgSource;
  }

  // Get the image from the preset imagesContext - this uses the base url of giftcardpro.app
  if (imgSource.includes("./presets/")) {
    return getPresetImage(imgSource, baseUrl);
  }
  
  if (imgSource.includes("./icons/") || imgSource.includes("./")) {
    return getWebpackImage(imgSource, baseUrl);
  }

  // The image is hosted on giftcardpro.app, so just return the regular url
  if (imgSource.includes("/presets/") && !imgSource.includes(baseUrl)) {
    // Normalize the image source to always start with a slash
    if (imgSource.charAt(0) !== "/") {
      imgSource = `/${imgSource}`;
    }
    return `${baseUrl}${imgSource}`;
  }

  // The image is hosted on giftcardpro.app, and already contains the images source
  if (imgSource.includes("/presets/")) {
    return imgSource
  }


  // Everything below here is hosted on S3

  // Replace the standard base url with the s3 url, only if not a preset
  if (imgSource.includes(baseUrl)) {
    return imgSource.replace(baseUrl, s3Url);
  }

  // Normalize the image source to always start with a slash
  if (imgSource.charAt(0) !== "/") {
    imgSource = `/${imgSource}`;
  }

  // If the image source does no include the full folder path, prepend it.
  if (!imgSource.includes(path)){
    // Treat these like they are uploads, but are missing the path.
      imgSource = `${path}${imgSource}`;
  }

  imgSource = imgSource.replace(" ", '%20');

  return `${s3Url}${imgSource}`;


}

/**
 * Helper function to create the path to the public uploads folder for a certain image
 *
 * @param { string } str - img name
 *
 * @return { string } str - public folder image path
 */
const createFileUrl = (imgName) => {
  if ( typeof ( APP_ADMIN ) != 'undefined' ) {
    return `/uploads/${APP_ADMIN.request.params.shop}/images/${imgName}`
  } else {
    return `/uploads/${GIST.myshopify_domain}/images/${imgName}`
  }
}

/**
 * Simple helper function to go from a image URL to the basename
 *
 * @param { string } str - img source or img Name.
 *
 * @return { string } str -  the image basename.
 */
export const getImgFileName = (imgSource) => {
  if (imgSource.includes("/")) {
    var expandedPath = imgSource.split("/")
    return expandedPath[expandedPath.length - 1]
  } else {
    return imgSource
  }
}

/**
 * Simple helper function check if the image is a preset image
 *
 * @param { string } str - img source or img Name.
 *
 * @return { string } str -  the image basename.
 */
export const checkImagePreset = (imgSource, imagePresets) => {
  let imgName = getImgFileName(imgSource)
  for (const [category, imgList] of Object.entries(imagePresets)) {
    if (imgList.includes(imgName)) {
      return true
    }
  }
  return false
}
